import { MTAdminAssignEntity } from '@/multi-territory/mt-components/mt-admin/MTAdminAssignEntity'
import MTAdminComplianceMaster from '@/multi-territory/mt-components/mt-admin/MTAdminComplianceMaster'
import { MTAdminEntity } from '@/multi-territory/mt-components/mt-admin/MTAdminEntity'
import { MTAdminTaxIdentificationNumber } from '@/multi-territory/mt-components/mt-admin/MTAdminTaxIdentificationNumber'
import { MTAdminTinForm } from '@/multi-territory/mt-components/mt-admin/MTAdminTinForm'
import { MTAdminUserSetup } from '@/multi-territory/mt-components/mt-admin/MTAdminUserSetup'
import { MTDuplicationRuleFormPage } from '@/multi-territory/mt-components/mt-returns/mt-define/MTDuplicationRuleFormPage'
import { MTDuplicationRulePage } from '@/multi-territory/mt-components/mt-returns/mt-define/MTDuplicationRulePage'
import { MTPayeeMasterPage } from '@/multi-territory/mt-components/mt-returns/mt-define/MTPayeeMasterPage'
import { MTRuleSettingFormPage } from '@/multi-territory/mt-components/mt-returns/mt-define/MTRuleSettingFormPage'
import { MTRuleSettingPage } from '@/multi-territory/mt-components/mt-returns/mt-define/MTRuleSettingPage'
import { MTServiceKeywordPage } from '@/multi-territory/mt-components/mt-returns/mt-define/MTServiceKeywordPage'
import { MTServiceMasterPage } from '@/multi-territory/mt-components/mt-returns/mt-define/MTServiceMasterPage'
import MTUpload from '@/multi-territory/mt-components/mt-returns/mt-upload/MTUpload'
import MTAllocate from '@/multi-territory/mt-components/mt-returns/MTAllocate'
import MTCompute from '@/multi-territory/mt-components/mt-returns/MTCompute'
import MTDefine from '@/multi-territory/mt-components/mt-returns/MTDefine'
import MTPrepare from '@/multi-territory/mt-components/mt-returns/MTPrepare'
import MTReturnsTab from '@/multi-territory/mt-components/mt-returns/MTReturnsTab'
import { MTAdmin } from '@/multi-territory/mt-pages/MTAdmin'
import { MTInsight } from '@/multi-territory/mt-pages/MTInsight'
import { MTProvisionAdvance } from '@/multi-territory/mt-pages/MTProvisionAdvance'
import { MTReturns } from '@/multi-territory/mt-pages/MTReturns'
import { MTSectionFormTestPage } from '@/multi-territory/mt-pages/MTSectionFormTestPage'
import { Navigate, Route, Routes } from 'react-router'
import { TANForm } from '../components/admin'
import {
  AuthGuard,
  ForgotPassword,
  Login,
  ProtectedRoute,
} from '../components/auth'
import SSOLogin from '../components/auth/SSOLogin'
import ComplianceTab from '../components/dashboard/ComplianceTab'
import DashboardTab from '../components/dashboard/DashboardTab'
import Compute from '../components/Returns/Compute/Compute'
import AddRuleSetting from '../components/Returns/Define/components/AddRuleSetting'
import WithholdingTaxPrepare from '../components/Returns/Prepare/Prepare'
import ReturnUpload from '../components/Returns/Upload/ReturnUpload'
import {
  Admin,
  COF,
  Dashboard,
  Download,
  DownloadTemplates,
  PremiumFeature,
  Provision,
  Returns,
  SelfService,
  UserManual,
} from '../pages'
import { IT_ADMIN } from '../utils/role-capabilities'
import { ROUTES } from './routeConfig'

const AppRoutes = () => {
  return (
    <Routes>
      {/* Root route - redirect to login */}
      <Route
        path={ROUTES.ROOT}
        element={<Navigate to={ROUTES.LOGIN} replace />}
      />

      <Route path="/test-section-form" element={<MTSectionFormTestPage />} />

      {/* Login route - protected by AuthGuard to prevent access if already logged in */}
      <Route
        path={ROUTES.LOGIN}
        element={
          <AuthGuard>
            <Login />
          </AuthGuard>
        }
      />
      <Route
        path="/:clientId"
        element={
          <AuthGuard>
            <Login />
          </AuthGuard>
        }
      />

      {/* SSO User List - must come before dynamic clientId route */}
      <Route path={ROUTES.LOGIN_USER_LIST} element={<SSOLogin />} />

      {/* Forgot Password */}
      <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPassword />} />

      {/* Dynamic client route for SSO - must come after specific login routes */}
      <Route
        path="/:clientId"
        element={
          <AuthGuard>
            <Login />
          </AuthGuard>
        }
      />

      {/* SSO User List - must come before dynamic clientId route */}
      <Route path={ROUTES.LOGIN_USER_LIST} element={<SSOLogin />} />

      {/* Forgot Password */}
      <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPassword />} />

      {/* Dynamic client route for SSO - must come after specific login routes */}
      <Route
        path="/:clientId"
        element={
          <AuthGuard>
            <Login />
          </AuthGuard>
        }
      />

      {/* Protected Dashboard route with child tabs */}
      <Route
        path={ROUTES.DASHBOARD}
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      >
        <Route
          index
          element={<Navigate to={ROUTES.DASHBOARD_OVERVIEW} replace />}
        />
        <Route path={ROUTES.DASHBOARD_OVERVIEW} element={<DashboardTab />} />
        <Route path={ROUTES.DASHBOARD_COMPLIANCE} element={<ComplianceTab />} />
      </Route>

      {/* Protected Returns route */}
      <Route
        path={ROUTES.RETURNS}
        element={
          <ProtectedRoute>
            <Returns />
          </ProtectedRoute>
        }
      />

      {/* Protected Provision route */}
      <Route
        path={ROUTES.PROVISION}
        element={
          <ProtectedRoute>
            <Provision />
          </ProtectedRoute>
        }
      />

      {/* Protected Admin route */}
      <Route
        path={ROUTES.ADMIN}
        element={
          <ProtectedRoute>
            <Admin />
          </ProtectedRoute>
        }
      />

      {/* Protected Download route */}
      <Route
        path={ROUTES.DOWNLOAD}
        element={
          <ProtectedRoute>
            <Download />
          </ProtectedRoute>
        }
      />

      {/* Protected Add TAN route */}
      <Route
        path={ROUTES.ADMIN_ADD_TAN}
        element={
          <ProtectedRoute>
            <TANForm />
          </ProtectedRoute>
        }
      />

      {/* Protected Edit TAN route */}
      <Route
        path={ROUTES.ADMIN_EDIT_TAN}
        element={
          <ProtectedRoute>
            <TANForm />
          </ProtectedRoute>
        }
      />

      <Route
        path={ROUTES.RETURNS_ADD_RULE}
        element={
          <ProtectedRoute>
            <AddRuleSetting />
          </ProtectedRoute>
        }
      />

      {/* Protected Help Center routes */}
      <Route
        path={ROUTES.HELP_USER_MANUAL}
        element={
          <ProtectedRoute>
            <UserManual />
          </ProtectedRoute>
        }
      />

      <Route
        path={ROUTES.HELP_COF}
        element={
          <ProtectedRoute>
            <COF />
          </ProtectedRoute>
        }
      />

      <Route
        path={ROUTES.HELP_DOWNLOAD_TEMPLATES}
        element={
          <ProtectedRoute>
            <DownloadTemplates />
          </ProtectedRoute>
        }
      />

      <Route
        path={ROUTES.RETURNS_PREPARE}
        element={
          <ProtectedRoute>
            <WithholdingTaxPrepare />
          </ProtectedRoute>
        }
      />

      <Route
        path={ROUTES.RETURNS_UPLOAD}
        element={
          <ProtectedRoute>
            <ReturnUpload />
          </ProtectedRoute>
        }
      />

      <Route
        path={ROUTES.RETURNS_COMPUTE}
        element={
          <ProtectedRoute>
            <Compute />
          </ProtectedRoute>
        }
      />

      <Route
        path={ROUTES.PREMIUM_FEATURE}
        element={
          <ProtectedRoute allowedRoles={[IT_ADMIN]}>
            <PremiumFeature />
          </ProtectedRoute>
        }
      />

      <Route
        path={ROUTES.SELF_SERVICE}
        element={
          <ProtectedRoute>
            <SelfService />
          </ProtectedRoute>
        }
      />

      {/* Multi-Territory routes */}
      <Route path={ROUTES.MT_INSIGHT} element={<MTInsight />} />
      <Route path={`${ROUTES.MT_RETURNS}/*`} element={<MTReturns />}>
        <Route
          index
          element={<Navigate to={ROUTES.MT_RETURNS_DEFINE_CHILD} replace />}
        />
        <Route
          path={`${ROUTES.MT_RETURNS_DEFINE_CHILD}/*`}
          element={<MTDefine />}
        >
          <Route path="SERVICE_MASTER" element={<MTServiceMasterPage />} />
          <Route
            path="section_service_keywords"
            element={<div>Section Service Keywords - Coming Soon</div>}
          />
          <Route path="SECTION_KEYWORD" element={<MTServiceKeywordPage />} />
          <Route path="rule_setting" element={<MTRuleSettingPage />} />
          <Route path="DUPLICATION_RULE" element={<MTDuplicationRulePage />} />
          <Route
            path="vendor_details"
            element={<div>Vendor Details - Coming Soon</div>}
          />
          <Route path="PAYEE_MASTER" element={<MTPayeeMasterPage />} />
        </Route>
        <Route path={ROUTES.MT_RETURNS_UPLOAD_CHILD} element={<MTUpload />} />
        <Route path={ROUTES.MT_RETURNS_PREPARE_CHILD} element={<MTPrepare />} />
        <Route path={ROUTES.MT_RETURNS_COMPUTE_CHILD} element={<MTCompute />} />
        <Route
          path={ROUTES.MT_RETURNS_ALLOCATE_CHILD}
          element={<MTAllocate />}
        />
        <Route
          path={ROUTES.MT_RETURNS_RETURNS_CHILD}
          element={<MTReturnsTab />}
        />
        <Route
          path={ROUTES.MT_RETURNS_REPORTS_CHILD}
          element={<div>Reports - Coming Soon</div>}
        />
      </Route>
      {/* MT Define Add/Edit Rule - full page */}
      <Route
        path={ROUTES.MT_RETURNS_DEFINE_ADD_RULE}
        element={<MTRuleSettingFormPage />}
      />
      {/* MT Define Add/Edit Duplication Rule - full page */}
      <Route
        path={ROUTES.MT_RETURNS_DEFINE_DUPLICATION_RULE_FORM}
        element={<MTDuplicationRuleFormPage />}
      />
      <Route
        path={ROUTES.MT_RETURNS_DEFINE_DUPLICATION_RULE_EDIT}
        element={<MTDuplicationRuleFormPage />}
      />

      <Route
        path={ROUTES.MT_PROVISION_ADVANCE}
        element={<MTProvisionAdvance />}
      />
      <Route path={`${ROUTES.MT_ADMIN}/*`} element={<MTAdmin />}>
        <Route
          index
          element={<Navigate to={ROUTES.MT_ADMIN_ENTITY_CHILD} replace />}
        />
        <Route
          path={ROUTES.MT_ADMIN_ENTITY_CHILD}
          element={<MTAdminEntity />}
        />
        <Route
          path={ROUTES.MT_ADMIN_TAX_IDENTIFICATION_NUMBER_CHILD}
          element={<MTAdminTaxIdentificationNumber />}
        />
        <Route
          path={ROUTES.MT_ADMIN_USER_SETUP_CHILD}
          element={<MTAdminUserSetup />}
        />
        <Route
          path={ROUTES.MT_ADMIN_ASSIGN_ENTITY_CHILD}
          element={<MTAdminAssignEntity />}
        />
        <Route
          path={ROUTES.MT_ADMIN_COMPLIANCE_MASTER_CHILD}
          element={<MTAdminComplianceMaster />}
        />
      </Route>

      {/* MT Admin TIN Create Form (full page) */}
      <Route path={ROUTES.MT_ADMIN_TIN_CREATE} element={<MTAdminTinForm />} />

      {/* MT Admin TIN Edit Form (full page) */}
      <Route path={ROUTES.MT_ADMIN_TIN_EDIT} element={<MTAdminTinForm />} />

      {/* Catch all route - redirect to login */}
      {/* <Route path="*" element={<Navigate to={ROUTES.LOGIN} replace />} /> */}
    </Routes>
  )
}

export default AppRoutes
